import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';

// Base locales configuration.
// They will be overwritten in middleware based on server data
export const routing = defineRouting({
    locales: ['en', 'az'],
    defaultLocale: 'az',
});

export type Locale = (typeof routing.locales)[number];

export const { Link, getPathname, redirect, usePathname, useRouter } = createNavigation(routing);
